import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: 'AI 赋能培训', path: '/training' },
  { label: 'AI 服务', path: '/software-services' },
  { label: '案例', path: '/cases' },
  { label: '关于', path: '/about' },
  { label: '联系', path: '/contact' },
];
const blogLink = { label: '洞察', path: '/blog' };

export default function Navbar({ solid }: { solid?: boolean }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const dark = solid || scrolled;

  useEffect(() => {
    if (solid) return;
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [solid]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        dark ? 'bg-white/95 backdrop-blur-sm border-b border-slate-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img src="/logo-icon.png" alt="宽思智能" className="w-8 h-8 rounded-lg" />
          <span
            className={`text-lg font-bold tracking-tight transition-colors duration-300 ${
              dark ? 'text-[#0F172A]' : 'text-white'
            }`}
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            宽思智能
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? dark ? 'text-[#0F172A]' : 'text-white'
                  : dark
                  ? 'text-[#64748B] hover:text-[#0F172A]'
                  : 'text-white/70 hover:text-white'
              }`}
              style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
          <span className={`w-px h-4 ${dark ? 'bg-slate-200' : 'bg-white/30'}`} />
          <Link
            to={blogLink.path}
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              location.pathname.startsWith('/blog')
                ? dark ? 'text-[#0F172A]' : 'text-white'
                : dark
                ? 'text-[#64748B] hover:text-[#0F172A]'
                : 'text-white/70 hover:text-white'
            }`}
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            {blogLink.label}
          </Link>
        </nav>

        {/* CTA Button */}
        <div className="hidden md:flex items-center">
          <Link
            to="/contact"
            className="px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 bg-[#F97316] text-white hover:bg-[#ea6c0a]"
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            预约交流
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="菜单"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl ${dark ? 'text-[#0F172A]' : 'text-white'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-2.5 cursor-pointer ${
                location.pathname === link.path ? 'text-[#0F172A]' : 'text-[#64748B]'
              }`}
              style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
          <div className="border-t border-slate-100 my-1" />
          <Link
            to={blogLink.path}
            className={`text-sm font-medium py-2.5 cursor-pointer ${
              location.pathname.startsWith('/blog') ? 'text-[#0F172A]' : 'text-[#64748B]'
            }`}
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            {blogLink.label}
          </Link>
          <Link
            to="/contact"
            className="mt-3 px-5 py-2.5 rounded-full text-sm font-medium text-center whitespace-nowrap cursor-pointer bg-[#F97316] text-white"
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            预约交流
          </Link>
        </div>
      )}
    </header>
  );
}
